import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../../components/ErpTemplate';
import { FaSave, FaBackward, FaThumbsUp, FaThumbsDown } from 'react-icons/fa';
import api from '../../../services/api';
import { useHistory, useLocation } from 'react-router-dom';
import { dataHora, dataMysql, parseCamposQuestionario, formatCrm, isNaoFarmaceutico, isEventoAmbos, categoriaTiposParticipante, CARGO_OUTROS, CATEGORIA_NAO_FARMACEUTICO } from '../../../util/util';
import ReactSelect from '../../../components/ReactSelect';
import InputMask from 'react-input-mask';
import { toast } from 'react-toastify';
import { getAuthPerfil, getAuthToken } from '../../../util/authSession';
import '../../../css/financeiro-parcela-pagar.css';
import { FinField, FinInput, FinTextarea } from '../../../components/FinField';


export default function CadastroEventoParticipanteLista({ match }) {
    const id = match.params.id;
    const token = getAuthToken();
    const perfil = getAuthPerfil();
    const [dados, setDados] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [dadosEvento, setDadosEvento] = useState({});
    const [camposQuestionario, setCamposQuestionario] = useState({});
    // ramo não farmacêutico: sem CRM nem especialidade. No evento
    // "Ambos" a lista recebe os dois ramos, e o de cada um segue o tipo escolhido no cadastro
    const naoFarmaceutico = isNaoFarmaceutico(dadosEvento, dados.tipoparticipante ?? '');
    const categoriaTipos = categoriaTiposParticipante(dadosEvento);
    // no "Ambos" o tipo aparece sempre, logo após o nome, e os campos de cada ramo só depois dele
    const eventoAmbos = isEventoAmbos(dadosEvento);
    const semTipoNoAmbos = eventoAmbos && !dados.tipoparticipante;
    const history = useHistory();
    let { state } = useLocation();
    const params = new URLSearchParams(window.location.search);
    var idEvento = state?.evento ?? params.get('evento') ?? null;
    // sem evento não há busca: começar em true deixaria o overlay preso para sempre
    const [isLoading, setIsLoading] = useState(!!idEvento);

    const aplicarDadosEvento = (dadosRecebidos) => {
        const mostrarTermo = !!(dadosRecebidos.termoaceiteassinatura && dadosRecebidos.termoaceiteassinatura !== '');

        setDados(dadosAtuais => ({
            ...dadosAtuais,
            evento: idEvento,
            tipoCadastro: 'participante',
            origemregistro: 'evento',
            situacaoRegistro: 'ativo',
            mostrarTermo: mostrarTermo,
            validarTudo: mostrarTermo,
        }));
        setDadosEvento(dadosRecebidos);

        const camposQuestionarioRecebidos = {
            ...parseCamposQuestionario(dadosRecebidos?.camposQuestionario),
            aereomunicipioembarque: 'nao', //esta tela nunca pede cidade de embarque
        };

        setCamposQuestionario(camposQuestionarioRecebidos);
    };

    const buscar = () => {
        if (idEvento) {
            api({
                method: "get",
                action: '/evento/listaPresencaResumo/' + idEvento,
                token: token,
            }).then(responseEvento => {
                aplicarDadosEvento({ ...responseEvento.data.data });
                setIsLoading(false);
            }).catch(err => {
                api({
                    method: "get",
                    action: '/evento/' + idEvento,
                    token: token,
                }).then(responseEvento => {
                    aplicarDadosEvento({ ...responseEvento.data.data });
                }).catch(() => {
                    //console.log(err)
                }).finally(() => {
                    // o fallback tem que liberar a tela nos dois desfechos, senão o overlay trava
                    setIsLoading(false);
                });
            });
        }//if idEvento
    };//buscar

    const validar = () => {
        var nome = document.querySelector("#nome");
        var cpf = document.querySelector("#cpf");

        if (nome && (dados.nome ?? '').trim() === '') {
            toast.error('É necessário preencher o nome');
            setTimeout(() => {
                nome?.focus();
            }, 500);
            return false;
        }

        if (cpf && (dados.cpf ?? '').trim() === '') {
            toast.error('É necessário preencher o CPF');
            setTimeout(() => {
                cpf?.focus();
            }, 500);
            return false;
        }

        return true;
    };

    const salvar = () => {

        if (isSubmitting) {
            return;
        }

        if (!validar()) {
            return false; //para codigo aqui
        }

        if (!idEvento) {
            toast.error('ID do evento não encontrado!');
            return false;
        }

        setIsSubmitting(true);

        delete dados.hoteldatacheckin;
        delete dados.hoteldatacheckout;
        delete dados.dataopcaoaereo;
        delete dados.datacartainformativa;
        delete dados.dataconfirmacaocartainformativa;
        delete dados.datacartaconvite;
        delete dados.datacartaassinada;
        delete dados.dataconfirmacaodados;
        delete dados.dataescolhaaereo;
        delete dados.datainscricao;
        delete dados.datacertificado;

        api({
            method: 'post',
            action: '/participante',
            token: token,
            data: dados
        })
            .then(function (response) {
                toast.success("Dados salvos com sucesso!");
                const participanteCriado = response.data?.data ?? {};
                const idParticipante = participanteCriado.id;

                if (!idParticipante) {
                    toast.error('Participante não retornou ID ao salvar.');
                    return;
                }

                if (['cliente'].includes(perfil)) {
                    history.push("/cadastroEventoParticipanteListaConcluido/" + idEvento);
                } else { // perfil listarsvp
                    history.push({
                        pathname: "/cadastroEventoParticipanteAssinatura/" + idParticipante,
                        search: '?' + new URLSearchParams({ evento: idEvento }).toString(),
                        state: {
                            evento: idEvento,
                        }
                    });
                }
            })
            .catch(function (error) {
                toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
            })
                .finally(() => {
                    setIsSubmitting(false);
                });
    }; //salvar

    useEffect(() => { //onload
        buscar();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate sidebar={['listarsvp', 'cliente'].includes(perfil) ? false : true}>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        <h2 className="fin-pp__title">Participante</h2>
                        {['listarsvp'].includes(perfil) && (
                            <a href={"/eventoParticipante/" + idEvento} className="fin-pp__btn fin-pp__btn--sm" style={{ marginTop: 8 }}>Participantes</a>
                        )}
                    </div>
                </div>
                <div className="fin-pp__card" style={{ padding: '16px' }}>
                    <form onSubmit={(e) => { salvar(); e.preventDefault(); }}>
                        {dados.mostrarTermo ? (
                            <>
                                <FinField label="Termo de Aceite" full>
                                    <textarea
                                        className="fin-pp__input"
                                        id="termoaceiteassinatura"
                                        style={{ height: 'auto', padding: '10px 14px', minHeight: '400px' }}
                                        value={dadosEvento?.termoaceiteassinatura}
                                        readOnly={true}
                                    />
                                </FinField>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16 }}>
                                    <button type='button' className="fin-pp__btn fin-pp__btn--danger"
                                        onClick={() => {
                                            history.push("/eventoParticipante/" + idEvento);
                                        }}>
                                        <FaThumbsDown size={14} style={{ marginRight: 6 }} /> Recusar
                                    </button>
                                    <button type='button' className="fin-pp__btn fin-pp__btn--primary"
                                        onClick={() => {
                                            dados.aceitetermoassinatura = 'sim';
                                            dados.mostrarTermo = false;
                                            setDados({ ...dados });
                                        }}>
                                        <FaThumbsUp size={14} style={{ marginRight: 6 }} /> Aceitar
                                    </button>
                                </div>
                            </>
                        ) : (
                            <>
                                {/* sem overlay: os campos dependem do questionário do evento, então
                                    enquanto ele não chega o card ficaria vazio sem explicação */}
                                {isLoading ? <div className="fin-pp__empty">Carregando os campos do evento…</div> : null}
                                <div className="fin-pp__filters">
                                    {(camposQuestionario.nome ?? "nao") === "sim" ? (
                                        <FinField label="Nome">
                                            <FinInput
                                                id="nome"
                                                value={dados.nome}
                                                onChange={e => setDados({ ...dados, ...{ "nome": e.target.value } })}
                                                style={{ paddingLeft: 14 }}
                                            />
                                        </FinField>
                                    ) : null}
                                    {eventoAmbos || (camposQuestionario.tipoparticipante ?? "nao") === "sim" ? (
                                        <FinField label="Tipo do Participante">
                                            <ReactSelect
                                                id="tipoparticipante"
                                                // o AsyncSelect cacheia as opções da montagem, quando a categoria
                                                // do evento ainda não resolveu; a key remonta o select
                                                key={categoriaTipos ?? 'todos'}
                                                value={{ value: dados.tipoparticipante, label: dados.nomeTipoparticipante }}
                                                onChange={e => setDados({ ...dados, ...{ "tipoparticipante": e.value, "nomeTipoparticipante": e.label } })}
                                                loadOptions={(input) => {
                                                    return api({
                                                        method: 'get',
                                                        action: '/participanteTipo',
                                                        token: token,
                                                        // a categoria do evento define quais tipos existem para ele (o "Ambos", todos)
                                                        params: { nome: input, categoria: categoriaTipos }
                                                    })
                                                        .then(response => {
                                                            let options = response.data.data.map(registro => ({ value: registro.id, label: registro.nome }));
                                                            return options;
                                                        })
                                                        .catch(function (error) {
                                                            //console.log(error);
                                                        });
                                                }}
                                            />
                                        </FinField>
                                    ) : null}
                                    {(camposQuestionario.instituicao ?? "nao") === "sim" ? (
                                        <FinField label="Instituição">
                                            <FinInput
                                                id="instituicao"
                                                value={dados.instituicao}
                                                onChange={e => setDados({ ...dados, ...{ "instituicao": e.target.value } })}
                                                style={{ paddingLeft: 14 }}
                                            />
                                        </FinField>
                                    ) : null}
                                    {(camposQuestionario.rg ?? "nao") === "sim" ? (
                                        <FinField label="RG">
                                            <FinInput
                                                id="rg"
                                                value={dados.rg}
                                                onChange={e => setDados({ ...dados, ...{ "rg": e.target.value } })}
                                                style={{ paddingLeft: 14 }}
                                            />
                                        </FinField>
                                    ) : null}
                                    {(camposQuestionario.email ?? "nao") === "sim" ? (
                                        <FinField label="E-mail">
                                            <FinInput
                                                id="email"
                                                value={dados.email}
                                                onChange={e => setDados({ ...dados, ...{ "email": e.target.value } })}
                                                style={{ paddingLeft: 14 }}
                                            />
                                        </FinField>
                                    ) : null}
                                    {!naoFarmaceutico && !semTipoNoAmbos && (camposQuestionario.crm ?? "nao") === "sim" ? (
                                        <FinField label="CRM">
                                            <FinInput
                                                id="crm"
                                                value={dados.crm ?? ''}
                                                onChange={e => {
                                                    const r = formatCrm(e.target.value, dados?.crm, dados?.crmuf);
                                                    setDados({ ...dados, ...{ "crm": r.crm, "crmuf": r.crmuf, "nomeUf": r.crmuf } });
                                                }}
                                                style={{ paddingLeft: 14 }}
                                            />
                                        </FinField>
                                    ) : null}
                                    {!naoFarmaceutico && !semTipoNoAmbos && (camposQuestionario.crmuf ?? "nao") === "sim" ? (
                                        <FinField label="Estado do CRM">
                                            <ReactSelect
                                                id="crmuf"
                                                value={{ value: dados.crmuf, label: dados.crmuf }}
                                                onChange={e => {
                                                    const r = formatCrm((e.value || '') + (dados?.crm ?? '').replace(/\D/g, ''), dados?.crm, e.value);
                                                    setDados({ ...dados, ...{ "crmuf": e.value, "nomeUf": e.label, "crm": r.crm } });
                                                }}
                                                options={[
                                                    { value: "AC", label: "AC" },
                                                    { value: "AL", label: "AL" },
                                                    { value: "AP", label: "AP" },
                                                    { value: "AM", label: "AM" },
                                                    { value: "BA", label: "BA" },
                                                    { value: "CE", label: "CE" },
                                                    { value: "DF", label: "DF" },
                                                    { value: "ES", label: "ES" },
                                                    { value: "GO", label: "GO" },
                                                    { value: "MA", label: "MA" },
                                                    { value: "MT", label: "MT" },
                                                    { value: "MS", label: "MS" },
                                                    { value: "MG", label: "MG" },
                                                    { value: "PA", label: "PA" },
                                                    { value: "PB", label: "PB" },
                                                    { value: "PR", label: "PR" },
                                                    { value: "PE", label: "PE" },
                                                    { value: "PI", label: "PI" },
                                                    { value: "RJ", label: "RJ" },
                                                    { value: "RN", label: "RN" },
                                                    { value: "RS", label: "RS" },
                                                    { value: "RO", label: "RO" },
                                                    { value: "RR", label: "RR" },
                                                    { value: "SC", label: "SC" },
                                                    { value: "SP", label: "SP" },
                                                    { value: "SE", label: "SE" },
                                                    { value: "TO", label: "TO" },
                                                ]}
                                            />
                                        </FinField>
                                    ) : null}
                                    {naoFarmaceutico && (camposQuestionario.cargoparticipante ?? "nao") === "sim" ? (
                                        <FinField label="Cargo">
                                            <ReactSelect
                                                id="cargoparticipante"
                                                value={dados.cargoparticipante ? { value: dados.cargoparticipante, label: dados.nomeCargoparticipante } : null}
                                                onChange={e => setDados({
                                                    ...dados,
                                                    ...{ "cargoparticipante": e ? e.value : '', "nomeCargoparticipante": e ? e.label : '' },
                                                    ...(e && String(e.value) === CARGO_OUTROS ? {} : { "cargoespecificacao": '' })
                                                })}
                                                loadOptions={(input) => {
                                                    return api({
                                                        method: 'get',
                                                        action: '/participanteCargo',
                                                        token: token,
                                                        params: { nome: input, categoria: CATEGORIA_NAO_FARMACEUTICO }
                                                    })
                                                        .then(response => response.data.data.map(registro => ({ value: registro.id, label: registro.nome })))
                                                        .catch(function (error) {
                                                            //console.log(error);
                                                        });
                                                }}
                                            />
                                        </FinField>
                                    ) : null}
                                    {naoFarmaceutico && (camposQuestionario.cargoparticipante ?? "nao") === "sim"
                                        && String(dados.cargoparticipante ?? '') === CARGO_OUTROS ? (
                                        <FinField label="Especificação do Cargo">
                                            <FinInput
                                                id="cargoespecificacao"
                                                value={dados.cargoespecificacao ?? ''}
                                                onChange={e => setDados({ ...dados, ...{ "cargoespecificacao": e.target.value } })}
                                                style={{ paddingLeft: 14 }}
                                            />
                                        </FinField>
                                    ) : null}
                                    {!naoFarmaceutico && !semTipoNoAmbos && (camposQuestionario.especialidade ?? "nao") === "sim" ? (
                                        <FinField label="Especialidade">
                                            <FinInput
                                                id="especialidade"
                                                value={dados.especialidade}
                                                onChange={e => setDados({ ...dados, ...{ "especialidade": e.target.value } })}
                                                style={{ paddingLeft: 14 }}
                                            />
                                        </FinField>
                                    ) : null}
                                    {(camposQuestionario.telefone ?? "nao") === "sim" ? (
                                        <FinField label="Telefone">
                                            <InputMask
                                                mask="(99) 99999-9999"
                                                id="telefone"
                                                className="fin-pp__input"
                                                value={dados.telefone}
                                                onChange={e => setDados({ ...dados, ...{ "telefone": e.target.value } })}
                                                style={{ paddingLeft: 14 }}
                                            />
                                        </FinField>
                                    ) : null}
                                    {(camposQuestionario.celular ?? "nao") === "sim" ? (
                                        <FinField label="Celular">
                                            <InputMask
                                                mask="(99) 99999-9999"
                                                id="celular"
                                                className="fin-pp__input"
                                                value={dados.celular}
                                                onChange={e => setDados({ ...dados, ...{ "celular": e.target.value } })}
                                                style={{ paddingLeft: 14 }}
                                            />
                                        </FinField>
                                    ) : null}
                                    {(camposQuestionario.datanascimento ?? "nao") === "sim" ? (
                                        <FinField label="Data de Nascimento">
                                            <input
                                                type="date"
                                                id="datanascimento"
                                                className="fin-pp__input"
                                                value={dados.datanascimento ?? ''}
                                                onChange={e => setDados({ ...dados, ...{ "datanascimento": e.target.value } })}
                                                style={{ paddingLeft: 14 }}
                                            />
                                        </FinField>
                                    ) : null}
                                    {(camposQuestionario.cpf ?? "nao") === "sim" ? (
                                        <FinField label="CPF">
                                            <InputMask
                                                mask="999.999.999-99"
                                                id="cpf"
                                                className="fin-pp__input"
                                                value={dados.cpf}
                                                onChange={e => setDados({ ...dados, ...{ "cpf": e.target.value } })}
                                                style={{ paddingLeft: 14 }}
                                            />
                                        </FinField>
                                    ) : null}
                                    {(camposQuestionario.passaporte ?? "nao") === "sim" ? (
                                        <FinField label="Passaporte">
                                            <FinInput
                                                id="passaporte"
                                                value={dados.passaporte}
                                                onChange={e => setDados({ ...dados, ...{ "passaporte": e.target.value } })}
                                                style={{ paddingLeft: 14 }}
                                            />
                                        </FinField>
                                    ) : null}
                                    {(camposQuestionario.passaportevencimento ?? "nao") === "sim" ? (
                                        <FinField label="Vencimento do Passaporte">
                                            <input
                                                type="date"
                                                id="passaportevencimento"
                                                className="fin-pp__input"
                                                value={dados.passaportevencimento ?? ''}
                                                onChange={e => setDados({ ...dados, ...{ "passaportevencimento": e.target.value } })}
                                                style={{ paddingLeft: 14 }}
                                            />
                                        </FinField>
                                    ) : null}
                                    {(camposQuestionario.enderecouf ?? "nao") === "sim" ? (
                                        <FinField label="Estado">
                                            <ReactSelect
                                                id="enderecouf"
                                                value={{ value: dados.enderecouf, label: dados.enderecouf }}
                                                onChange={e => setDados({ ...dados, ...{ "enderecouf": e.value, "nomeUf": e.label } })}
                                                options={[
                                                    { value: "AC", label: "AC" },
                                                    { value: "AL", label: "AL" },
                                                    { value: "AP", label: "AP" },
                                                    { value: "AM", label: "AM" },
                                                    { value: "BA", label: "BA" },
                                                    { value: "CE", label: "CE" },
                                                    { value: "DF", label: "DF" },
                                                    { value: "ES", label: "ES" },
                                                    { value: "GO", label: "GO" },
                                                    { value: "MA", label: "MA" },
                                                    { value: "MT", label: "MT" },
                                                    { value: "MS", label: "MS" },
                                                    { value: "MG", label: "MG" },
                                                    { value: "PA", label: "PA" },
                                                    { value: "PB", label: "PB" },
                                                    { value: "PR", label: "PR" },
                                                    { value: "PE", label: "PE" },
                                                    { value: "PI", label: "PI" },
                                                    { value: "RJ", label: "RJ" },
                                                    { value: "RN", label: "RN" },
                                                    { value: "RS", label: "RS" },
                                                    { value: "RO", label: "RO" },
                                                    { value: "RR", label: "RR" },
                                                    { value: "SC", label: "SC" },
                                                    { value: "SP", label: "SP" },
                                                    { value: "SE", label: "SE" },
                                                    { value: "TO", label: "TO" },
                                                ]}
                                            />
                                        </FinField>
                                    ) : null}
                                    {(camposQuestionario.enderecomunicipio ?? "nao") === "sim" ? (
                                        <FinField label="Cidade">
                                            <ReactSelect
                                                value={{ value: dados.enderecomunicipio, label: dados.nomeEnderecomunicipio }}
                                                onChange={e => setDados({ ...dados, ...{ "enderecomunicipio": e.value, "nomeEnderecomunicipio": e.label } })}
                                                loadOptions={(input) => {
                                                    return api({
                                                        method: 'get',
                                                        action: '/municipio',
                                                        token: token,
                                                        params: {
                                                            nome: input,
                                                            uf: dados.enderecouf ?? null
                                                        }
                                                    })
                                                        .then(response => {
                                                            let options = response.data.data.map(registro => ({ value: registro.id, label: registro.nome + "-" + registro.uf }));
                                                            return options;
                                                        })
                                                        .catch(function (error) {
                                                            //console.log(error);
                                                        });
                                                }}
                                            />
                                        </FinField>
                                    ) : null}
                                    {(camposQuestionario.aereomunicipioembarque ?? "nao") === "sim" ? (
                                        <FinField label="Cidade de Embarque">
                                            <ReactSelect
                                                value={{ value: dados.aereomunicipioembarque, label: dados.nomeAereomunicipioembarque }}
                                                onChange={e => setDados({ ...dados, ...{ "aereomunicipioembarque": e.value, "nomeAereomunicipioembarque": e.label } })}
                                                loadOptions={(input) => {
                                                    return api({
                                                        method: 'get',
                                                        action: '/municipio',
                                                        token: token,
                                                        params: {
                                                            nome: input,
                                                            uf: dados.enderecouf ?? null
                                                        }
                                                    })
                                                        .then(response => {
                                                            let options = response.data.data.map(registro => ({ value: registro.id, label: registro.nome + "-" + registro.uf }));
                                                            return options;
                                                        })
                                                        .catch(function (error) {
                                                            //console.log(error);
                                                        });
                                                }}
                                            />
                                        </FinField>
                                    ) : null}
                                    {(camposQuestionario.enderecologradouro ?? "nao") === "sim" ? (
                                        <FinField label="Logradouro">
                                            <FinInput
                                                id="enderecologradouro"
                                                value={dados.enderecologradouro}
                                                onChange={e => setDados({ ...dados, ...{ "enderecologradouro": e.target.value } })}
                                                style={{ paddingLeft: 14 }}
                                            />
                                        </FinField>
                                    ) : null}
                                    {(camposQuestionario.endereconumero ?? "nao") === "sim" ? (
                                        <FinField label="Número">
                                            <FinInput
                                                id="endereconumero"
                                                value={dados.endereconumero}
                                                onChange={e => setDados({ ...dados, ...{ "endereconumero": e.target.value } })}
                                                style={{ paddingLeft: 14 }}
                                            />
                                        </FinField>
                                    ) : null}
                                    {(camposQuestionario.enderecocomplemento ?? "nao") === "sim" ? (
                                        <FinField label="Complemento">
                                            <FinInput
                                                id="enderecocomplemento"
                                                value={dados.enderecocomplemento}
                                                onChange={e => setDados({ ...dados, ...{ "enderecocomplemento": e.target.value } })}
                                                style={{ paddingLeft: 14 }}
                                            />
                                        </FinField>
                                    ) : null}
                                    {(camposQuestionario.enderecocep ?? "nao") === "sim" ? (
                                        <FinField label="CEP">
                                            <FinInput
                                                id="enderecocep"
                                                value={dados.enderecocep}
                                                onChange={e => setDados({ ...dados, ...{ "enderecocep": e.target.value } })}
                                                style={{ paddingLeft: 14 }}
                                            />
                                        </FinField>
                                    ) : null}
                                    {(camposQuestionario.enderecobairro ?? "nao") === "sim" ? (
                                        <FinField label="Bairro">
                                            <FinInput
                                                id="enderecobairro"
                                                value={dados.enderecobairro}
                                                onChange={e => setDados({ ...dados, ...{ "enderecobairro": e.target.value } })}
                                                style={{ paddingLeft: 14 }}
                                            />
                                        </FinField>
                                    ) : null}
                                    {(camposQuestionario.vinculoOrgaoPublico ?? "nao") === "sim" ? (
                                        <FinField label="Vínculo com Órgão Público">
                                            <ReactSelect
                                                id="vinculoOrgaoPublico"
                                                value={{ value: dados.vinculoOrgaoPublico, label: (dados.vinculoOrgaoPublico === 'sim' ? 'Sim' : dados.vinculoOrgaoPublico === 'nao' ? 'Não' : '') }}
                                                onChange={e => setDados({ ...dados, ...{ "vinculoOrgaoPublico": e.value } })}
                                                options={[
                                                    { value: "sim", label: "Sim" },
                                                    { value: "nao", label: "Não" },
                                                ]}
                                            />
                                        </FinField>
                                    ) : null}
                                    {/* Colunas nomeaveis: definicoes do evento (`dadosEvento.colunas`), sem 1..10 fixo — a 11a entra
                                        sozinha. So as perguntadas e nao travadas no cadeado. */}
                                    {(dadosEvento.colunas ?? []).map(coluna => {
                                        if (!coluna.questionar || !coluna.ativo) {
                                            return null;
                                        }
                                        // Esta tela CRIA participante: a definição vem do evento e o valor
                                        // digitado vive em `dados.colunas`, que é o que o POST manda.
                                        const preenchida = (dados.colunas ?? []).find(atual => atual.ordem === coluna.ordem);
                                        return (
                                            <FinField key={coluna.id} label={coluna.nome}>
                                                <FinInput
                                                    id={'coluna' + coluna.ordem}
                                                    value={preenchida?.valor ?? ''}
                                                    onChange={e => {
                                                        const valor = e.target.value;
                                                        const atuais = dados.colunas ?? [];
                                                        const jaTem = atuais.some(atual => atual.ordem === coluna.ordem);
                                                        setDados({
                                                            ...dados,
                                                            colunas: jaTem
                                                                ? atuais.map(atual => (atual.ordem === coluna.ordem ? { ...atual, valor } : atual))
                                                                : [...atuais, { id: coluna.id, ordem: coluna.ordem, valor }],
                                                        });
                                                    }}
                                                    style={{ paddingLeft: 14 }}
                                                />
                                            </FinField>
                                        );
                                    })}
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
                                    <button type="submit" className="fin-pp__btn fin-pp__btn--primary" disabled={isLoading || isSubmitting}>
                                        {isLoading ? 'Carregando...' : (isSubmitting ? 'Salvando...' : 'Salvar')}
                                    </button>
                                </div>
                            </>
                        )}
                    </form>
                </div>
            </div>
        </ErpTemplate>
    );
}
